// src/main.jsx
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

// styles
import "./style.css";
import "@/bootstrap-custom.scss";
import "@/components/CSS/MobileMenu.scss";

// 👉 add this: our lightweight locale provider (create the file below)
import { LocaleProvider } from "@/locale/LocaleContext.jsx";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(
  <React.StrictMode>
    {/* App-wide language state (en/fr) */}
    <LocaleProvider>
      <Router>
        <App />
      </Router>
    </LocaleProvider>
  </React.StrictMode>
);
